export default __webpack_public_path__ + "static/media/construction.1415e2f7.svg";